import { VueConstructor } from "vue";
import CoverQuestion from "./CoverQuestion.vue";
import { QuestionFormat } from "@/modules/onboarding/hod/model/vetting/model";

export const QUIZ_FORM_COMPONENTS: Record<QuestionFormat, VueConstructor> = {
    "cover-question": CoverQuestion,
};
